import { __rest } from 'tslib';
import React, { useRef, useEffect } from 'react';
import { styled } from '@teko/ds-desktop';
import { DropdownProvider } from './DropdownContext.es.js';

const Dropdown = (_a) => {
    var { children, isOpen, toggle, toggleType = 'click', className, onHide } = _a, props = __rest(_a, ["children", "isOpen", "toggle", "toggleType", "className", "onHide"]);
    const wrapperRef = useRef(null);
    useEffect(() => {
        if (!isOpen) {
            return;
        }
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                toggle();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef, isOpen]);
    return (React.createElement(DropdownProvider, { value: { isOpen, toggle, toggleType } },
        React.createElement(DropdownWrapper, Object.assign({ onMouseEnter: toggleType === 'hover' ? toggle : null, onMouseLeave: toggleType === 'hover' ? onHide : null, className: className, ref: wrapperRef }, props), children)));
};
const DropdownWrapper = styled.div `
  width: 100%;
`;

export { Dropdown };
